export default {
    accountManagerGP: "stats/accountManagerGP",
    
    accountManagerTotalGP: "stats/accountManagerTotalGP",

    allAccountsTotalGp: "stats/allAccountsTotalGp",

    volumes: "stats/volumes",
    volumesByService: "stats/volumesByService",

    priceForProduct: "provisioningProfile/forCustomerAndProduct",
    accountProductTotalsByReference: "stats/accountProductTotalsByReference",
    accountProductTotalsByService: "stats/accountProductTotalsByService",

    dailyGP: "stats/dailyGP",
    totalCostsAndPrices: "stats/totalCostsAndPrices",
    hourlyAverage: "stats/hourlyAverage",

}